import { LocaleServiceConfig } from '@volkswagen-onehub/locale-service';

enum Languages {
  EN = 'en',
  DE = 'de',
}

export function createConsumerLocale(): LocaleServiceConfig {
  return {
    language: Languages.DE,
    countryCode: 'DE',
    brand: 'V',
    currency: 'EUR',
    market: 'DEU',
  };
}
